<template>
  <v-dialog 
    v-model="dialog"
    @click:outside="$emit('update:activated', false)"
    max-width="900" 
    scrollable
  >
    <v-card>
      <v-card-title class="headline font-weight-bold">Selecionar Cálculo de COM e CA:</v-card-title>
      <v-row align="center" no-gutters>
        <v-col cols="12">
          <v-text-field
           v-show="!loading"
            v-model="search"
            append-icon="mdi-magnify"
            class="mx-10 py-4"
            label="Procurar"
            hide-details
            single-line
          />
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="itemsPerPage"
            :search.sync="search"
            :page.sync="currentPage"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            :mobile-breakpoint="0"
            no-data-text="Nenhum cálculo disponível"
            no-results-text="Nenhum registro correspondente encontrado"
          >
            <template v-slot:item="row">
              <tr @click="selecionar(row.item)">
                <td class="button cursor-pointer" style="max-width: 70px"> {{ row.item.id }} </td>
                <td class="button cursor-pointer" style="max-width: 220px">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <div class="text-truncate" v-bind="attrs" v-on="on">
                      {{ row.item.nome }}
                    </div>
                    </template>
                    <span>{{ row.item.nome }}</span>
                  </v-tooltip>
                </td>
                <td class="button cursor-pointer text-no-wrap">{{ row.item.usuario.nome }}</td>
                <td class="button cursor-pointer">{{ row.item.data_processamento | replaceFullDate}}</td>
              </tr>
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" @click="getCalculosStatusSucesso()">mdi-refresh</v-icon>
                </template>
                <span>Clique aqui para recarregar os cálculos</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import CalculosComCaService from '@/services/CalculosComCaService.js';

export default {
  props: {
    activated: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    currentPage: 1,
    itemsPerPage: 5,
    search: undefined,
    headers: [
      {
        text: "#",
        value: "id"
      },
      {
        text: "Nome",
        value: "nome"
      },
      {
        text: "Usuário",
        value: "usuario"
      },
      {
        text: "Executado",
        value: "data_processamento"
      }
    ],
    items: [],
    loading: false
  }),

  computed: {
    dialog() {
      return this.activated;
    }
  },

  created() {
    this.getCalculosStatusSucesso();
  },

  methods: {
    getCalculosStatusSucesso() {
      this.items = [];
      this.loading = true;

      CalculosComCaService.getCalculosByStatus("SUCESSO")
        .then(response => this.items = response.data.calculos)
        .catch(() => this.$toast.error("Erro ao recuperar cálculo de com ca", "", {position: "topRight"}))
        .finally(() => this.loading = false);
    },

    selecionar(calculo) {
      const data = {typeSelector: 'calculoComCa', id: calculo.id, nome: calculo.nome};
      this.$emit("selected", data);

      setTimeout(() => { this.search = "" }, 500);
    }
  },

  watch: {
    search() {
      this.currentPage = 1;
    }
  }
}
</script>

<style scoped>
.cursor-pointer:hover {
  cursor: pointer;
}
</style>